import React from "react";
import SectionShell from "../../components/sections/SectionShell";
import AIManager from "../AIManager";
import Chat from "../Chat";
import AIWorkers from "../AIWorkers";
import AIUsagePanel from "./AIUsagePanel";

// AI Studio merges AI Manager (briefs, alerts, plan approvals), the Copilot
// conversation and AI Workers (campaign drafts). Every call goes through the
// backend AI router; provider configuration stays in Settings > AI.
export const AI_STUDIO_TABS = [
  { id: "today", label: "Today", icon: "☀️", render: () => <AIManager />,
    description: "Daily brief, alerts and plan proposals waiting for your approval." },
  { id: "copilot", label: "Copilot", icon: "💬", render: () => <Chat />,
    description: "Ask about your fans, content, platforms and money. Answers use your CRM data." },
  { id: "campaigns", label: "Campaigns", icon: "📣", render: () => <AIWorkers />,
    description: "Mass-message campaigns are drafted for review; nothing is sent without you." },
  { id: "usage", label: "Usage", icon: "📈", render: () => <AIUsagePanel />,
    description: "Provider health, token use and estimated cost per route." },
];

// Old page names and tab ids still land on the right tab.
export const AI_STUDIO_TAB_ALIASES = {
  manager: "today", "ai-manager": "today", brief: "today", approvals: "today",
  chat: "copilot", workers: "campaigns", "ai-workers": "campaigns", health: "usage",
};

export default function AIStudioSection() {
  return (
    <SectionShell
      sectionId="ai"
      title="AI Studio"
      overline="TODAY · COPILOT · CAMPAIGNS · UNIFIED AI ROUTING"
      tabs={AI_STUDIO_TABS}
      aliases={AI_STUDIO_TAB_ALIASES}
    />
  );
}
